var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf_view",on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();}}},_vm._l((_vm.pageTotal),function(item){return _c('pdf',{key:item,attrs:{"src":_vm.pdfUrlShow,"page":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }